import { render, staticRenderFns } from "./TrademarkOppositionStatus.vue?vue&type=template&id=c373fc56&"
import script from "./TrademarkOppositionStatus.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports